// import React from 'react';
// import { motion } from 'framer-motion';

// // ==============================
// // Utility Helpers
// // ==============================
// const uid = (prefix = '') => `${prefix}${Math.random().toString(36).slice(2, 9)}`;

// // ==============================
// // Additional Certifications Data
// // ==============================
// const additionalCertifications = [
//    {
//     id: uid('cert_'), 
//     name: 'Responsive Web Design', 
//     issuer: 'Freecodecamp',
//     year: 'Nov,2023', 
//     tags: ['Data', 'Analytics'],
//     filePath: '/pictures/certifications/9-responsive_web_design.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'C Programming language', 
//     issuer: 'neoColab - LPU', 
//     year: 'May,2024', 
//     tags: ['AI', 'No-Code', 'Generative AI'],
//     filePath: '/pictures/certifications/10-C.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'C Programming language', 
//     issuer: 'CSE Pathshala', 
//     year: 'March,2024', 
//     tags: ['Cloud', 'DevOps', 'Containerization'],
//     filePath: '/pictures/certifications/11-C(2).pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'CPP - Object Oriented Programming', 
//     issuer: 'neoColab - LPU', 
//     year: 'December,2024', 
//     tags: ['Database', 'NoSQL'],
//     filePath: '/pictures/certifications/12-CPP.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Data Structures and Algorithms', 
//     issuer: 'neoColab - LPU', 
//     year: 'December,2024', 
//     tags: ['Containerization', 'DevOps'],
//     filePath: '/pictures/certifications/13-DSA.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'JAVA Programming Language', 
//     issuer: 'neoColab - LPU', 
//     year: 'May,2025', 
//     tags: ['Security', 'Cybersecurity'],
//     filePath: '/pictures/certifications/14-JAVA.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'ChatGPT Made Easy:AI Essentials for Beginners', 
//     issuer: 'Udemy', 
//     year: 'August,2025', 
//     tags: ['Agile', 'Project Management'],
//     filePath: '/pictures/certifications/15-chatgpt made easy.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'ChatGPT-4 Prompt Engineering: ChatGPT, Generative AI & LLM', 
//     issuer: 'Infosys', 
//     year: 'August,2025', 
//     tags: ['Analytics', 'Marketing'],
//     filePath: '/pictures/certifications/16-chatgpt-4.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Computational Theory: Language Principle & Finite Automata Theory', 
//     issuer: 'Infosys', 
//     year: 'September,2025', 
//     tags: ['Cloud', 'Architecture'],
//     filePath: '/pictures/certifications/17-Computational theory.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Introduction to Hardware and Operating Systems', 
//     issuer: 'Coursera - IBM', 
//     year: 'September,2024', 
//     tags: ['Cloud', 'Development'],
//     filePath: '/pictures/certifications/18-Introduction to Hardware and Operating Systems.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Master Generative AI & Generative AI tools (ChatGPT & more)', 
//     issuer: 'Udemy', 
//     year: 'September,2025', 
//     tags: ['Programming', 'Python'],
//     filePath: '/pictures/certifications/19-Master Generative AI & Generative AI tools (ChatGPT & more).pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Data Structures and Algorithm', 
//     issuer: 'SkillStone', 
//     year: 'July,2025', 
//     tags: ['Project Management', 'Leadership'],
//     filePath: '/pictures/certifications/20-pep-DSA.pdf'
//   }
// ];

// const MoreCertificationsPage = () => {
//   // Function to go back to the main page
//   const goBack = () => {
//     window.location.href = '/';
//   };

//   return (
//     <div className="relative min-h-screen py-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
//       {/* Animated Background Elements */}
//       <motion.div 
//         className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-800 to-black opacity-95"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 1 }}
//       />
      
//       <motion.div 
//         className="absolute top-10 left-10 w-64 h-64 bg-primary-cyan/10 rounded-full blur-3xl"
//         animate={{ 
//           x: [0, 20, 0],
//           y: [0, -20, 0],
//           scale: [1, 1.1, 1]
//         }}
//         transition={{ 
//           duration: 15,
//           repeat: Infinity,
//           repeatType: "reverse"
//         }}
//       />
      
//       <motion.div 
//         className="absolute bottom-20 right-20 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl"
//         animate={{ 
//           x: [0, -30, 0],
//           y: [0, 30, 0],
//           scale: [1, 1.2, 1]
//         }}
//         transition={{ 
//           duration: 20,
//           repeat: Infinity,
//           repeatType: "reverse"
//         }}
//       />
      
//       <motion.div 
//         className="absolute top-1/3 right-1/4 w-40 h-40 bg-blue-400/10 rounded-full blur-3xl"
//         animate={{ 
//           x: [0, 40, 0],
//           y: [0, 40, 0],
//         }}
//         transition={{ 
//           duration: 12,
//           repeat: Infinity,
//           repeatType: "reverse"
//         }}
//       />

//       <div className="max-w-7xl mx-auto relative z-10">
//         <motion.header 
//           className="text-center mb-12"
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//         > 
//           <motion.div
//             className="rounded-2xl backdrop-blur-lg border border-gray-700 p-6 bg-transparent"
//           >
//             <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
//               <span className="bg-gradient-to-r from-primary-cyan to-blue-400 bg-clip-text text-transparent">Additional Certifications</span>
//             </h1>
//             <p className="text-lg text-gray-300 max-w-3xl mx-auto">
//               Explore more of my professional certifications and continuous learning journey.
//             </p>
//           </motion.div>
//         </motion.header>

//         <motion.main 
//           initial={{ opacity: 0, y: 14 }} 
//           animate={{ opacity: 1, y: 0 }} 
//           transition={{ duration: 0.45 }}
//         >
//           <div className="grid grid-cols-1 gap-6">
//             <motion.div 
//               className="rounded-2xl p-6 bg-gradient-to-br from-gray-800/40 to-gray-900/30 backdrop-blur-lg border border-gray-700"
//               initial={{ opacity: 0, x: -20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <div className="flex justify-between items-center mb-6">
//                 <div>
//                   <h3 className="text-lg font-bold text-white">Professional Certifications</h3>
//                   <p className="text-gray-400 mt-1">Additional verified certifications and credentials.</p>
//                 </div>
//                 <button 
//                   onClick={goBack}
//                   className="px-4 py-2 rounded-md bg-primary-cyan text-white font-medium hover:bg-primary-cyan/90 transition-colors flex items-center gap-2"
//                 >
//                   <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
//                   </svg>
//                   Back to Main Page
//                 </button>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                 {additionalCertifications.map((cert) => (
//                   <motion.div 
//                     key={cert.id} 
//                     className="rounded-lg p-4 bg-white/3 backdrop-blur-sm border border-white/5 hover:border-primary-cyan/30 transition-colors h-56 flex flex-col justify-between"
//                     whileHover={{ y: -3 }}
//                     transition={{ duration: 0.2 }}
//                   >
//                     <div className="flex items-start justify-between">
//                       <div>
//                         <div className="text-sm text-gray-300">{cert.issuer} • {cert.year}</div>
//                         <div className="text-lg font-semibold text-white mt-1">{cert.name}</div>
//                         <div className="flex gap-2 mt-2 flex-wrap">
//                           {cert.tags.map((tag, i) => (
//                             <span key={i} className="text-xs px-2 py-1 bg-primary-cyan/10 text-primary-cyan rounded-full">
//                               {tag}
//                             </span>
//                           ))}
//                         </div>
//                       </div>
//                       <div className="flex flex-col items-end gap-3">
//                         <div className="text-xs bg-green-900/30 text-green-400 px-2 py-1 rounded">Verified</div>
//                       </div>
//                     </div>
//                     <div className="flex justify-end mt-4">
//                       <button 
//                         className="text-xs text-primary-cyan hover:text-cyan-300 transition-colors"
//                         onClick={() => window.open(cert.filePath, '_blank')}
//                       >
//                         View Details →
//                       </button>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </motion.div>
//           </div>
//         </motion.main>
//       </div>
//     </div>
//   );
// };

// export default MoreCertificationsPage;



import React from 'react';
import { motion } from 'framer-motion';

// ==============================
// Utility Helpers
// ==============================
const uid = (prefix = '') => `${prefix}${Math.random().toString(36).slice(2, 9)}`;

// ==============================
// Additional Certifications Data with Image Placeholders
// ==============================
const additionalCertifications = [
  {
    id: uid('cert_'), 
    name: 'Responsive Web Design', 
    issuer: 'Freecodecamp',
    year: 'Nov,2023', 
    tags: ['Data', 'Analytics'],
    filePath: '/pictures/certifications/9-responsive_web_design.pdf',
    imagePath: 'https://www.simplilearn.com/ice9/free_resources_article_thumb/is_web_development_good_career.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'C Programming language', 
    issuer: 'neoColab - LPU', 
    year: 'May,2024', 
    tags: ['AI', 'No-Code', 'Generative AI'],
    filePath: '/pictures/certifications/10-C.pdf',
    imagePath: 'https://img.freepik.com/premium-photo/abstract-modern-tech-programming-code-screen-developer-c-programming-language-computer-script-technology-background-software_505353-434.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Master Generative AI & Generative AI tools (ChatGPT & more)', 
    issuer: 'Udemy', 
    year: 'September,2025', 
    tags: ['Programming', 'Python'],
    filePath: '/pictures/certifications/19-Master Generative AI & Generative AI tools (ChatGPT & more).pdf',
    imagePath: 'https://img.freepik.com/free-photo/3d-colorful-abstract-background-generative-ai_91128-2275.jpg?semt=ais_hybrid&w=740&q=80'
  },
  { 
    id: uid('cert_'), 
    name: 'C Programming language', 
    issuer: 'CSE Pathshala', 
    year: 'March,2024', 
    tags: ['Cloud', 'DevOps', 'Containerization'],
    filePath: '/pictures/certifications/11-C(2).pdf',
    imagePath: 'https://c8.alamy.com/comp/2G18XE3/abstract-modern-tech-of-programming-code-screen-developer-c-programming-language-of-computer-script-and-technology-background-of-software-2G18XE3.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'ChatGPT Made Easy:AI Essentials for Beginners', 
    issuer: 'Udemy', 
    year: 'August,2025', 
    tags: ['Agile', 'Project Management'],
    filePath: '/pictures/certifications/15-chatgpt made easy.pdf',
    imagePath: 'https://insidetelecom.com/wp-content/uploads/2023/07/MicrosoftTeams-image-8-1024x576.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'CPP - Object Oriented Programming', 
    issuer: 'neoColab - LPU', 
    year: 'December,2024', 
    tags: ['Database', 'NoSQL'],
    filePath: '/pictures/certifications/12-CPP.pdf',
    imagePath: 'https://habrastorage.org/webt/ck/dk/lt/ckdkltwzaocqpwpfvoqerbmerja.png'
  },
  { 
    id: uid('cert_'), 
    name: 'Data Structures and Algorithms', 
    issuer: 'neoColab - LPU', 
    year: 'December,2024', 
    tags: ['Containerization', 'DevOps'],
    filePath: '/pictures/certifications/13-DSA.pdf',
    imagePath: 'https://e1.pxfuel.com/desktop-wallpaper/923/737/desktop-wallpaper-algorithms-and-data-structures-in-action-version-13-data-structures.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'JAVA Programming Language', 
    issuer: 'neoColab - LPU', 
    year: 'May,2025', 
    tags: ['Security', 'Cybersecurity'],
    filePath: '/pictures/certifications/14-JAVA.pdf',
    imagePath: 'https://img2.wallspic.com/crops/8/0/3/3/6/163308/163308-java-graphic_design-logo-text-graphics-3840x2160.png'
  },
  { 
    id: uid('cert_'), 
    name: 'ChatGPT-4 Prompt Engineering: ChatGPT, Generative AI & LLM', 
    issuer: 'Infosys', 
    year: 'August,2025', 
    tags: ['Analytics', 'Marketing'],
    filePath: '/pictures/certifications/16-chatgpt-4.pdf',
    imagePath: 'https://insidetelecom.com/wp-content/uploads/2023/07/MicrosoftTeams-image-8-1024x576.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Computational Theory: Language Principle & Finite Automata Theory', 
    issuer: 'Infosys', 
    year: 'September,2025', 
    tags: ['Cloud', 'Architecture'],
    filePath: '/pictures/certifications/17-Computational theory.pdf',
    imagePath: 'https://algocademy.com/blog/wp-content/uploads/2024/12/compressed_image-223.webp'
  },
  { 
    id: uid('cert_'), 
    name: 'Introduction to Hardware and Operating Systems', 
    issuer: 'Coursera - IBM', 
    year: 'September,2024', 
    tags: ['Cloud', 'Development'],
    filePath: '/pictures/certifications/18-Introduction to Hardware and Operating Systems.pdf',
    imagePath: 'https://w0.peakpx.com/wallpaper/468/927/HD-wallpaper-parrot-os-parrot-security.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Data Structures and Algorithm', 
    issuer: 'SkillStone', 
    year: 'July,2025', 
    tags: ['Project Management', 'Leadership'],
    filePath: '/pictures/certifications/20-pep-DSA.pdf',
    imagePath: 'https://e1.pxfuel.com/desktop-wallpaper/923/737/desktop-wallpaper-algorithms-and-data-structures-in-action-version-13-data-structures.jpg'
  }
];

// Image Placeholder Component for when image is missing
const CertificateImage = ({ imagePath, certName }) => {
  const [imageError, setImageError] = React.useState(false);

  if (imageError || !imagePath) {
    return (
      <div className="w-full h-32 bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
        <div className="text-center">
          <svg className="w-8 h-8 text-gray-400 mx-auto mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="text-xs text-gray-500">Certificate Preview</span>
        </div>
      </div>
    );
  }

  return (
    <img 
      src={imagePath} 
      alt={certName}
      className="w-full h-32 object-cover rounded-lg"
      onError={() => setImageError(true)}
    />
  );
};

const MoreCertificationsPage = () => {
  // Function to go back to the main page
  const goBack = () => {
    window.location.href = '/';
  };

  return (
    <div className="relative min-h-screen py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-white">
      {/* Animated Background Elements - Adjusted for white background */}
      <motion.div 
        className="absolute inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-100"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />
      
      <motion.div 
        className="absolute top-10 left-10 w-64 h-64 bg-primary-cyan/5 rounded-full blur-3xl"
        animate={{ 
          x: [0, 20, 0],
          y: [0, -20, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          duration: 15,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <motion.div 
        className="absolute bottom-20 right-20 w-72 h-72 bg-purple-500/5 rounded-full blur-3xl"
        animate={{ 
          x: [0, -30, 0],
          y: [0, 30, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 20,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <motion.div 
        className="absolute top-1/3 right-1/4 w-40 h-40 bg-blue-400/5 rounded-full blur-3xl"
        animate={{ 
          x: [0, 40, 0],
          y: [0, 40, 0],
        }}
        transition={{ 
          duration: 12,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.header 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        > 
          <motion.div
            className="rounded-2xl backdrop-blur-lg border border-gray-200 p-6 bg-white/80 shadow-sm"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
              <span className="bg-gradient-to-r from-primary-cyan to-blue-600 bg-clip-text text-transparent">Additional Certifications</span>
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Explore more of my professional certifications and continuous learning journey.
            </p>
          </motion.div>
        </motion.header>

        <motion.main 
          initial={{ opacity: 0, y: 14 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.45 }}
        >
          <div className="grid grid-cols-1 gap-6">
            <motion.div 
              className="rounded-2xl p-6 bg-white shadow-lg border border-gray-200"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex justify-between items-center mb-6 flex-wrap gap-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-900">Professional Certifications</h3>
                  <p className="text-gray-500 mt-1">Additional verified certifications and credentials.</p>
                </div>
                <button 
                  onClick={goBack}
                  className="px-4 py-2 rounded-md bg-primary-cyan text-white font-medium hover:bg-blue-600 transition-colors flex items-center gap-2 shadow-sm"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Back to Main Page
                </button>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {additionalCertifications.map((cert) => (
                  <motion.div 
                    key={cert.id} 
                    className="rounded-lg bg-gray-50 border border-gray-200 hover:border-primary-cyan/50 hover:shadow-md transition-all overflow-hidden flex flex-col"
                    whileHover={{ y: -3 }}
                    transition={{ duration: 0.2 }}
                  >
                    {/* Certificate Image Section */}
                    <div className="relative group">
                      <CertificateImage imagePath={cert.imagePath} certName={cert.name} />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                        <button 
                          onClick={() => window.open(cert.filePath, '_blank')}
                          className="bg-white/90 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-xs font-medium shadow-lg"
                        >
                          View Certificate →
                        </button>
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-4 flex flex-col flex-grow">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="text-xs text-gray-500">{cert.issuer} • {cert.year}</div>
                          <div className="text-md font-semibold text-gray-900 mt-1 line-clamp-2">{cert.name}</div>
                          <div className="flex gap-2 mt-2 flex-wrap">
                            {cert.tags.map((tag, i) => (
                              <span key={i} className="text-xs px-2 py-1 bg-primary-cyan/10 text-primary-cyan rounded-full">
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className="flex flex-col items-end gap-2 ml-2">
                          <div className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded whitespace-nowrap">Verified</div>
                        </div>
                      </div>
                      
                      <div className="flex justify-end mt-3 pt-2 border-t border-gray-200">
                        <button 
                          className="text-sm text-primary-cyan hover:text-blue-600 transition-colors font-medium flex items-center gap-1"
                          onClick={() => window.open(cert.filePath, '_blank')}
                        >
                          View Details
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </motion.main>
      </div>
    </div>
  );
};

export default MoreCertificationsPage;